import React, { useState, useEffect } from 'react';
import { Select, Spin, message } from 'antd';
import Parse from '../../config/parse';

const { Option } = Select;

const MedicalSpecialtySelector = ({ value = [], onChange }) => {
  const [specialties, setSpecialties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSpecialties = async () => {
      try {
        setLoading(true);
        
        // Consultar todas las especialidades médicas
        const MedicalSpecialty = Parse.Object.extend('MedicalSpecialty');
        const query = new Parse.Query(MedicalSpecialty);
        query.equalTo('status', 'active');
        query.ascending('name');
        query.limit(1000); // Límite alto para obtener todas
        
        const results = await query.find();
        
        setSpecialties(results.map(specialty => ({
          id: specialty.id,
          name: specialty.get('name'),
          description: specialty.get('description')
        })));
        
      } catch (err) {
        console.error('Error al cargar especialidades médicas:', err);
        message.error('No se pudieron cargar las especialidades médicas');
      } finally {
        setLoading(false);
      }
    };

    fetchSpecialties();
  }, []);

  const handleChange = (selectedIds) => {
    if (onChange) {
      onChange(selectedIds);
    }
  };

  const filterOption = (input, option) => 
    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  return (
    <Select
      mode="multiple"
      style={{ width: '100%' }}
      placeholder="Selecciona especialidades médicas"
      value={value}
      onChange={handleChange}
      optionFilterProp="children"
      filterOption={filterOption}
      loading={loading}
      notFoundContent={loading ? <Spin size="small" /> : 'No hay especialidades disponibles'}
      maxTagCount={5}
    >
      {specialties.map(specialty => (
        <Option key={specialty.id} value={specialty.id} title={specialty.description}>
          {specialty.name}
        </Option>
      ))}
    </Select>
  );
};

export default MedicalSpecialtySelector;
